import { Link, Navigate } from "react-router";
import { useAuth, useNotes } from "../../hooks";

export default function NotesList() {
  const { getNotesByUser, addNote, deleteNote } = useNotes();
  const { user } = useAuth();

  if (!user?.username) {
    return <Navigate to="/login" replace />;
  }

  const notes = getNotesByUser(user.username);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();

    // Early return if user somehow becomes null
    if (!user?.username) return;

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const title = formData.get("title") as string;
    const description = formData.get("description") as string;

    try {
      await addNote(user.username, title, description);
      form.reset();
    } catch (error) {
      console.error("Failed to add note:", error);
    }
  }

  return (
    <div className="flex flex-col gap-12 justify-around mt-8">
      <form onSubmit={onSubmit} className="flex flex-col w-64 mb-4">
        <input
          name="title"
          type="text"
          placeholder="Title"
          required
          className="mb-2 p-2 border border-gray-300 rounded"
        />
        <input
          name="description"
          type="text"
          placeholder="Description"
          required
          className="mb-4 p-2 border border-gray-300 rounded"
        />
        <button
          type="submit"
          className="bg-blue-500 text-white rounded px-4 py-2"
        >
          Add Note
        </button>
      </form>

      <ul>
        <h2 className="text-2xl font-bold mb-4">Notes:</h2>
        {notes.map((n) => (
          <div
            key={n.id}
            className="flex flex-row justify-between items-start border rounded-2xl gap-8 p-2 m-2"
          >
            <Link
              to={`/notes/${n.id}`}
              className="text-blue-500 hover:underline"
            >
              <strong>{n.title}</strong>
            </Link>
            <button className="text-red-500" onClick={() => deleteNote(n.id)}>
              X
            </button>
          </div>
        ))}
      </ul>
    </div>
  );
}
